export function appStoreDialog() {
    let hasTouchScreen = false;
    if ("maxTouchPoints" in navigator) {
        hasTouchScreen = navigator.maxTouchPoints > 0;
    } else if ("msMaxTouchPoints" in navigator) {
        hasTouchScreen = navigator.msMaxTouchPoints > 0;
    } else {
        const mQ = matchMedia?.("(pointer:coarse)");
        if (mQ?.media === "(pointer:coarse)") {
            hasTouchScreen = !!mQ.matches;
        } else if ("orientation" in window) {
            hasTouchScreen = true; // deprecated, but good fallback
        } else {
            // Only as a last resort, fall back to user agent sniffing
            const UA = navigator.userAgent;
            hasTouchScreen =
            /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) ||
            /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
        }
    }
    let titleText = "";
    let introText = "";
    let pricingText = "";
    let availableText = "";
    let dataRateText = "";
    if(document.documentElement.lang === 'en-US') {
        titleText = "Download the Oportun app";
        introText = "Scan the QR code with your phone’s camera to download the app. Signing up is simple, you’ll be ready to go in less than 5 minutes.";
        pricingText = "It’s free to download and manage your personal loan or credit card. Our savings and investing tools are free for 30 days and $5 per month after.";
        availableText = "Available on Apple and Android.";
        dataRateText = "Standard data rates may apply.";
    }else{
        titleText = "Obtén la aplicación de Oportun";
        introText = "Escanea el código QR con la cámara de tu teléfono para descargar la aplicación. Inscribirse es fácil y en menos de 5 minutos estará todo listo.";
        pricingText = "Descargarla y manejar tu préstamo personal o tarjeta de crédito es gratis. Nuestra herramienta de ahorro, Set & SaveTM, es gratis por 30 dias y $5 al mes después.";
        availableText = "Disponible en Apple y Android.";
        dataRateText = "Aplican tarifas estándar de datos y mensajería por llamadas, mensajes de texto o descargas. Usar la app para manejar la cuenta de su préstamo o tarjeta de crédito es gratis. La función opcional de ahorros cuesta $5 al mes después del periodo de prueba y usted puede cancelar en cualquier momento. Esta aplicación de Oportun y los servicios relacionados son opcionales.";
    }
    if( document.querySelector('.oportun-appstore-button') ) {
        const dialogHtml = `<div class="dialog-content">
            <div class="head">
            <header>
                <div class="logo">
                    <img src="/wp-content/themes/oportun/dist/assets/brand/logo-9e5df3d0f41fe70d.svg">
                </div>
                <div class="actions"></div>
            </header>
            <div class="close-btn">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <use href="/wp-content/themes/oportun/dist/assets/brand/icons-e36237469627580c.svg?24#close"></use>
                </svg>
            </oportun-icon></div>
            </div>

            <div class="content">
            <h1>` + titleText + `</h1>
            <div class="intro">
                ` + introText + `
            </div>
            <div class="qrcode">
                <oportun-download-qrcode width="250" height="250"></oportun-download-qrcode>
            </div>
            <div class="pricing">
                ` + pricingText + `
            </div>
            </div>
            <footer>
            <div class="store-icons">
                <span>` + availableText + `</span>
                <span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                    <use href="/wp-content/themes/oportun/dist/assets/brand/graphics-9a32387d1a799542.svg?13#appstore-logo"></use>
                </svg>
                </span>
                <span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
                    <use href="/wp-content/themes/oportun/dist/assets/brand/graphics-9a32387d1a799542.svg?13#playstore-logo-mark"></use>
                </svg>
                </span>
            </div>
            <div class="disclaimer">` + dataRateText + `</div>
            </footer>
        </div>`;
        const dialogElement = document.createElement('dialog');
        dialogElement.innerHTML = dialogHtml;
        dialogElement.setAttribute("id", "download-dialog")
        dialogElement.setAttribute("open", "");
        dialogElement.querySelector(".close-btn").addEventListener('click', (e) => {
            document.querySelector("dialog#download-dialog").close();
        });
        dialogElement.setAttribute("role", "dialog");
        const buttons = document.querySelectorAll('.oportun-appstore-button');
        buttons.forEach(
            (element) => {
                element.addEventListener('click', (e) => {
                    if(hasTouchScreen){
                        return;
                    }
                    e.preventDefault();
                    if(document.querySelector("dialog#download-dialog")){
                        document.querySelector("dialog#download-dialog").showModal();
                    }else{
                        document.querySelector('body > footer').appendChild(dialogElement);
                    }
                });
            }
        );
    }
}